module.exports = __webpack_public_path__ + "img/collectorbank.a163c81.png";